import * as React from 'react';
import './index.css';
import { i18nClient } from '@sailor/i18n-mach-pro';
import { openPunctualLandingPage } from '@/src/utils/router';
import { isEqual, throttle } from 'lodash';
import { highlightListForText } from '@/src/pages/order/order_status_golden/utils';

const Intl = Mach.requireModule('Intl');

interface IProps {
  detailData?: any;
  lateCompensationLabel?: any;
  onClose?: Function;
  onDisplay?: Function;
  skipOrderViewId?: boolean;
  lx: {
    promisePopupMv: (params) => void;
    promisePopupRuleMc: (params) => void;
    promisePopupGotItMc: (params) => void;
  };
}

export class PromisePopupView extends React.Component<IProps, any> {
  // 记录弹窗曝光
  recordPopupViewMV: any = {};

  constructor(props: IProps) {
    super(props);
    this.onLxView();
  }

  componentDidMount(): void {
    const { onDisplay } = this.props;
    onDisplay?.();
  }

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const { lateCompensationLabel, onDisplay } = this.props;
    const prevLateCompensationLabel = prevProps.lateCompensationLabel;
    const dataChanged = lateCompensationLabel && prevLateCompensationLabel
      && !isEqual(prevLateCompensationLabel, lateCompensationLabel);
    if (dataChanged) {
      onDisplay?.();
      this.onLxView();
    }
  }

  /**
   * 弹窗曝光
   */
  onLxView = () => {
    const { lateCompensationLabel, lx } = this.props;
    const { lateCompensationLabelPop } = lateCompensationLabel || {};
    const { items } = lateCompensationLabelPop || {};
    let index = items?.findIndex((it) => it.selected === 1) ?? -1;
    if (index === -1) {
      index = 0;
    } else {
      index += 1;
    }
    const hasReportMV = this.recordPopupViewMV[index];
    if (hasReportMV) {
      return;
    }
    this.recordPopupViewMV[index] = true;
    const params = this.getLxCommonParams();
    lx?.promisePopupMv(params);
  }

  /**
   * 规则按钮点击
   */
  onRuleLxClick = () => {
    const { lx } = this.props;
    const params = this.getLxCommonParams();
    lx?.promisePopupRuleMc(params);
  }

  /**
   * 我知道了点击
   */
  onGotLxClick = () => {
    const { lx } = this.props;
    const params = this.getLxCommonParams();
    lx?.promisePopupGotItMc(params);
  }

  /**
   * 曝光通用参数
   * @returns
   */
  getLxCommonParams = () => {
    const { detailData, lateCompensationLabel } = this.props;
    const { lateCompensationLabelPop } = lateCompensationLabel || {};
    const { items, effected } = lateCompensationLabelPop || {};
    let popupViewType = 0;
    if (effected) {
      const index: number = items?.findIndex((it) => it.selected === 1);
      if (index !== -1) {
        popupViewType = index + 1;
      }
    }
    return {
      module_type: popupViewType,
      order_view_id: detailData?.orderBaseInfo?.orderViewId || '-999',
    };
  }

  /**
   * 渲染赔付券金额信息
   */
  renderCouponInfoItem = (item, index) => {
    const width = item.selected ? 75 : 60;
    let backgroundWidth = width;
    let imageUrl = 'assets://order/order_status_golden/promise_coupon_uneffected.png';
    if (item.selected) {
      imageUrl = index > 0 ? 'assets://order/order_status_golden/promise_coupon_high_effected.png' : 'assets://order/order_status_golden/promise_coupon_low_effected.png';
      backgroundWidth = index > 0 ? 85 : 75;
    }
    const amount = item.amount || '';
    const desc = item.lateTimeStr || '';
    return (
      <view key={index} className="coupon-info-item" style={{ width: backgroundWidth }}>
        <view style={{
          marginTop: item.selected ? 16 : 24,
        }}
        >
          <view
            className="coupon-amount-info"
            style={{
              height: item.selected ? 56 : 45,
            }}
          >
            <image
              className="coupon-amount-info-background"
              resizeMode="widthFix"
              src={imageUrl}
              autoRTL
            />
            <text
              className="coupon-amount-text"
              style={{
                fontSize: item.selected ? 16 : 13,
                opacity: item.selected ? 1 : 0.6,
                color: item.selected ? '#7B3E00' : '#898CA0',
                marginRight: (item.selected && index > 0) ? 10 : 0,
              }}
              content={amount}
            />
          </view>
        </view>
        <text
          className="coupon-desc"
          style={{
            marginTop: item.selected ? 5 : 8,
            marginRight: (item.selected && index > 0) ? 10 : 0,
            color: item.selected ? '#222222' : '#808080',
          }}
          content={desc}
        />
      </view>
    );
  }

  /**
   * 券分隔视图
   */
  renderCouponInfoItemDivider = (item, index) => (
    <image
      className="divider-arrow"
      key={index}
      src="assets://order/order_status_golden/promise_coupon_arrow.png"
      autoRTL
    />
  )

  /**
   * 点击查看规则
   */
  handleClickRule = throttle(() => {
    const { detailData, skipOrderViewId } = this.props;
    const { orderInfo, orderBaseInfo } = detailData || {};
    const shopId = orderInfo?.shopInfo.shopId;
    const orderViewId = orderBaseInfo?.orderViewId;
    const shopRegion = orderInfo?.shopInfo?.shopRegion;
    if (!shopId || (!skipOrderViewId && !orderViewId)) {
      return;
    }
    this.onRuleLxClick();
    // 关闭弹窗
    this.handleClose();
    // 打开准时宝规则页
    openPunctualLandingPage({
      shopId,
      orderViewId,
      shopRegion,
    });
  }, 1000, { leading: true, trailing: false });

  /**
   * 关闭弹窗
   */
  handleClose = () => {
    const { onClose } = this.props;
    onClose?.();
  }

  /**
   * 点击知道了事件
   */
  handleClickGotIt = () => {
    this.onGotLxClick();
    this.handleClose();
  }

  getCouponInfoItemData = () => {
    const { lateCompensationLabel } = this.props;
    const { lateCompensationLabelPop } = lateCompensationLabel || {};
    const { items } = lateCompensationLabelPop || {};
    return items?.reduce((acc, item, index) => {
      acc.push(item);
      if (index < items.length - 1) {
        acc.push({ style: 1 }); // 券间隔视图
      }
      return acc;
    }, []) || [];
  }

  gethackRTLClassName(prefix) {
    const isRTL = Intl?.isRTL?.() ?? false;

    return `${prefix}__${isRTL ? 'left' : 'right'}`;
  }

  render() {
    const { lateCompensationLabel } = this.props;
    const { lateCompensationLabelPop } = lateCompensationLabel || {};
    const {
      fullTitle, subTitle
    } = lateCompensationLabelPop || {};
    const safeAreaBottom = Mach.env.safeAreaInsets.bottom || 16;
    const gotText = i18nClient.getText('order_detail_page_ontimepopup_button_gotit');
    const ruleText = i18nClient.getText('order_detail_page_ontimepopup_button');
    const btnWidth = (Mach.env.screenWidth - 33) / 2;
    const couponInfoItems = this.getCouponInfoItemData();
    const isRTL = Intl?.isRTL?.() ?? false;

    return (
      <view className="root">
        <view className="container" style={{ paddingBottom: safeAreaBottom }}>
          <image
            className="bg"
            src="assets://punctual/onTimePromiseHalfModalBg.png"
            resizeMode="scaleToFill"
          />
          <view className={`title-info ${this.gethackRTLClassName('title-info')}`}>
            <adaptive-text
              className="title"
              style={{
                maxLines: 0,
              }}
              content={fullTitle || ''}
              minFontSize={isRTL ? 24 : 18}
            />
          </view>
          <rich-text
            className={`subtitle ${this.gethackRTLClassName('subtitle')}`}
            content={highlightListForText(`${subTitle}`).map((item) => ({
              type: 'text',
              text: item.text,
              fontSize: 13,
              fontFamily: item.highlight ? 'KeeTa-Bold' : 'KeeTa-Regular',
              color: item.highlight ? '#F14E24' : '#222222',
            }))}
          />
          {/* 赔付券信息 */}
          <view className="coupon-info-shadow">
            <view
              className="coupon-info-radius"
              style={{
                justifyContent: couponInfoItems?.length > 5 ? 'space-between' : 'space-around',
              }}
            >
              {couponInfoItems?.map((it, idx) => {
                if (it.style === 1) {
                  return this.renderCouponInfoItemDivider(it, idx);
                } else {
                  return this.renderCouponInfoItem(it, idx);
                }
              })}
            </view>
          </view>
          <view className="button-container">
            {/* 规则按钮 */}
            <view
              className="rule-btn"
              style={{ width: btnWidth }}
              onClick={() => {
                this.handleClickRule();
              }}
            >
              <text className="rule-btn-text" content={ruleText} />
            </view>
            {/* 确认按钮 */}
            <view
              className="got-it-btn"
              style={{ width: btnWidth }}
              onClick={() => {
                this.handleClickGotIt();
              }}
            >
              <text className="got-it-btn-text">{gotText}</text>
            </view>
          </view>
        </view>
        <image
          className={`alarm ${this.gethackRTLClassName('alarm')}`}
          src="assets://punctual/promiseLight.png"
        />
      </view>
    );
  }
}
